import useMyMutation from './useMyMutation'
import { API } from 'lib/api'
import { apiName } from 'config/api'

export const usePranalysisMutaion = () => {
    return useMyMutation({
        mutationFn: async (param) => {
            const ret = await API.post(apiName, '/items/postPRAnalysis', { body: param })
            return ret
        },
        queryKey: ['pranalysis'],
        to: '/pranalysis',
    })
}
